<template>
  <div>
    <div class="overlay"></div>
    <div class="modal_fixed" v-if="swipoGameThemes !== 'SEASONAL'">
      <div v-if="swipoGameThemes === 'NO_CATEGORY' || swipoCategories.length === 1" class="modal_box modal_cont new_game new_game_3" id="modal_new_game3">
        <div class="new_game_title">{{ getTranslations.home_pre_game_modal3_title }}</div>
        <div class="new_game_txt" id="clicked">
          {{ getTranslations.home_pre_game_modal3_txt1 }} <span>{{ getTranslations.home_pre_game_modal3_txt2 }}</span> {{ getTranslations.home_pre_game_modal3_txt3 }} <br>
          {{ getTranslations.home_pre_game_modal3_txt4 }}
        </div>
        <div class="new_game_txt">
          <span>{{ getTranslations.home_pre_game_modal3_swipe }}</span> <br>
          {{ getTranslations.home_pre_game_modal3_points }}
        </div>
        <div class="new_game_txt">
          {{ getTranslations.home_pre_game_modal3_good_luck }}
        </div>
        <img src="/static/images/big_prizes.png" class="big_prizes">

        <div class="d_row end_row">
          <div class="unlocked_games"><span>{{ userDetails.availableGames }}</span> {{ getTranslations.home_pre_game_modal3_unlocked }}</div>
        </div>

      </div>
      <div v-else-if="swipoGameThemes === 'ALL' || (swipoGameThemes !== 'NO_CATEGORY' && swipoCategories.length >= 5)" class="modal_box modal_cont new_game new_game_1" id="modal_new_game1">
        <div class="new_game_title">{{ getTranslations.home_pre_game_modal1_title }}</div>
        <div class="d_row first">
          <div :class="['cat_box', swipoCategories[0].toLowerCase()]" @click.prevent="showCategory(swipoCategories[0])" style="cursor:pointer">{{ translateCategory(swipoCategories[0].toLowerCase()) }}</div>
          <div v-if="swipoCategories.length === 6 ||  swipoCategories.length === 8" :class="['cat_box', (swipoCategories.length === 6) ? swipoCategories[5].toLowerCase() : swipoCategories[7].toLowerCase()]" @click.prevent="showCategory((swipoCategories.length === 6) ? swipoCategories[5] : swipoCategories[7])" style="cursor:pointer">
            {{ (swipoCategories.length === 6) ? translateCategory(swipoCategories[5].toLowerCase()) : translateCategory(swipoCategories[7].toLowerCase()) }}
          </div>
        </div>
        <div class="d_row">
          <div :class="['cat_box', swipoCategories[1].toLowerCase()]" @click.prevent="showCategory(swipoCategories[1])" style="cursor:pointer">{{ translateCategory(swipoCategories[1].toLowerCase()) }}</div>
          <div :class="['cat_box', swipoCategories[2].toLowerCase()]" @click.prevent="showCategory(swipoCategories[2])" style="cursor:pointer">{{ translateCategory(swipoCategories[2].toLowerCase()) }}</div>
        </div>
        <div class="d_row">
          <div :class="['cat_box', swipoCategories[3].toLowerCase()]" @click.prevent="showCategory(swipoCategories[3])" style="cursor:pointer">{{ translateCategory(swipoCategories[3].toLowerCase()) }}</div>
          <div :class="['cat_box', swipoCategories[4].toLowerCase()]" @click.prevent="showCategory(swipoCategories[4])" style="cursor:pointer">{{ translateCategory(swipoCategories[4].toLowerCase()) }}</div>
        </div>
        <div class="d_row">
          <div :class="['cat_box', (swipoCategories.length > 6) ? swipoCategories[5].toLowerCase() : '']" @click.prevent="showCategory((swipoCategories.length >= 6) ? swipoCategories[5] : '')" style="cursor:pointer">{{ (swipoCategories.length >= 6) ?  translateCategory(swipoCategories[5].toLowerCase()) : ''}}</div>
          <div :class="['cat_box', (swipoCategories.length >= 7) ? swipoCategories[6].toLowerCase() : '']" @click.prevent="showCategory((swipoCategories.length >= 7) ? swipoCategories[6] : '')" style="cursor:pointer">{{ (swipoCategories.length >= 7) ? translateCategory(swipoCategories[6].toLowerCase()) : ''}}</div>
        </div>
        <div class="d_row">
          <div :class="['cat_box', (swipoCategories.length > 8) ? swipoCategories[7].toLowerCase() : '']" @click.prevent="showCategory((swipoCategories.length >= 8) ? swipoCategories[7] : '')" style="cursor:pointer">{{ (swipoCategories.length >= 8) ? translateCategory(swipoCategories[7].toLowerCase()) : ''}}</div>
          <div :class="['cat_box', (swipoCategories.length === 9) ? swipoCategories[8].toLowerCase() : '']" @click.prevent="showCategory((swipoCategories.length === 9) ? swipoCategories[8] : '')" style="cursor:pointer">{{ (swipoCategories.length === 9) ? translateCategory(swipoCategories[8].toLowerCase()) : ''}}</div>
        </div>
      </div>
      <div v-else-if="swipoGameThemes !== 'NO_CATEGORY' && swipoCategories.length >=1 && swipoCategories.length <= 4" class="modal_box modal_cont new_game new_game_4" id="modal_new_game4">
          <div class="new_game_title">{{ getTranslations.home_pre_game_modal4_title }}</div>
          <div class="d_col">
            <div class="border" v-for="category in swipoCategories" :key="category">
              <div class="cat_box_few" @click.prevent="showCategory(category)">{{ translateCategory(category.toLowerCase()) }}</div>
            </div>
          </div>
      </div>
    </div>
    <div class="modal_fixed" v-else>
      <div v-if="swipoCategories.length === 1" class="modal_box modal_cont new_game new_game_3" id="modal_new_game3">
        <div class="new_game_title">{{ getTranslations.home_pre_game_modal3_title }}</div>
        <div class="new_game_txt" id="clicked">
          {{ getTranslations.home_pre_game_modal3_txt1 }} <span>{{ getTranslations.home_pre_game_modal3_txt2 }}</span> {{ getTranslations.home_pre_game_modal3_txt3 }} <br>
          {{ getTranslations.home_pre_game_modal3_txt4 }}
        </div>
        <div class="new_game_txt">
          <span>{{ getTranslations.home_pre_game_modal3_swipe }}</span> <br>
          {{ getTranslations.home_pre_game_modal3_points }}
        </div>
        <div class="new_game_txt">
          {{ getTranslations.home_pre_game_modal3_good_luck }}
        </div>
        <img src="/static/images/big_prizes.png" class="big_prizes">

        <div class="d_row end_row">
          <div class="unlocked_games"><span>{{ userDetails.availableGames }}</span> {{ getTranslations.home_pre_game_modal3_unlocked }}</div>
        </div>

      </div>
      <div v-else-if="swipoCategories.length >= 5" class="modal_box modal_cont new_game new_game_1" id="modal_new_game1">
        <div class="new_game_title">{{ getTranslations.home_pre_game_modal1_title }}</div>
        <div class="d_row first">
          <div :class="['cat_box']" @click.prevent="showCategory(swipoCategories[0].type)" :style="{ cursor: 'pointer',  backgroundColor: getColor(swipoCategories[0]) }"
              >{{ swipoCategories[0].name }}</div>
          <div v-if="swipoCategories.length === 6 ||  swipoCategories.length === 8" :class="['cat_box']"
               :style="{ cursor: 'pointer', backgroundColor: getColor(swipoCategories[(swipoCategories.length === 6) ? 5 : 7]) }"   @click.prevent="showCategory((swipoCategories.length === 6) ? swipoCategories[5].type : swipoCategories[7].type)" >
            {{ (swipoCategories.length === 6) ? swipoCategories[5].name : swipoCategories[7].name }}
          </div>
        </div>
        <div class="d_row">
          <div :class="['cat_box']" @click.prevent="showCategory(swipoCategories[1].type)"  :style="{ cursor: 'pointer',  backgroundColor: getColor(swipoCategories[1]) }">{{ swipoCategories[1].name }}</div>
          <div :class="['cat_box']" @click.prevent="showCategory(swipoCategories[2].type)" :style="{ cursor: 'pointer',  backgroundColor: getColor(swipoCategories[2]) }">{{ swipoCategories[2].name }}</div>
        </div>
        <div class="d_row">
          <div :class="['cat_box']" @click.prevent="showCategory(swipoCategories[3].type)" :style="{ cursor: 'pointer',  backgroundColor: getColor(swipoCategories[3]) }">{{ swipoCategories[3].name }}</div>
          <div :class="['cat_box']" @click.prevent="showCategory(swipoCategories[4].type)"  :style="{ cursor: 'pointer',  backgroundColor: getColor(swipoCategories[4]) }">{{ swipoCategories[4].name }}</div>
        </div>
        <div class="d_row">
          <div :class="['cat_box']" @click.prevent="showCategory((swipoCategories.length >= 6) ? swipoCategories[5].type : '')"  :style="{ cursor: 'pointer',  backgroundColor: getColor(swipoCategories[5]) }"      v-if="swipoCategories.length > 6" >{{ (swipoCategories.length >= 6) ?  swipoCategories[5].name : ''}}</div>
          <div :class="['cat_box']" @click.prevent="showCategory((swipoCategories.length >= 7) ? swipoCategories[6].type: '')"  :style="{ cursor: 'pointer',  backgroundColor: getColor(swipoCategories[6]) }" v-if="swipoCategories.length > 7">{{ (swipoCategories.length >= 7) ? swipoCategories[6].name : ''}}</div>
        </div>
        <div class="d_row">
          <div :class="['cat_box', (swipoCategories.length > 8) ? swipoCategories[7].type.toLowerCase() : '']" @click.prevent="showCategory((swipoCategories.length >= 8) ? swipoCategories[7].type : '')"   v-if="swipoCategories.length > 8">{{ (swipoCategories.length >= 8) ? swipoCategories[7].name : ''}}</div>
          <div :class="['cat_box']" @click.prevent="showCategory((swipoCategories.length === 9) ? swipoCategories[8].type : '')"  :style="{cursor: 'pointer',  backgroundColor: getColor(swipoCategories[8]) }" v-if="swipoCategories.length == 9">{{ (swipoCategories.length === 9) ? swipoCategories[8].name : ''}}</div>
        </div>
      </div>
      <div v-else-if="swipoCategories.length >=1 && swipoCategories.length <= 4" class="modal_box modal_cont new_game new_game_4" id="modal_new_game4">
        <div class="new_game_title">{{ getTranslations.home_pre_game_modal4_title }}</div>
        <div class="d_col">
          <div class="border" v-for="category in swipoCategories" :key="category">
            <div class="cat_box_few" @click.prevent="showCategory(category.type)">{{ category.name }}</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
/* eslint no-console: "off" */
import { mapActions, mapGetters, mapMutations, mapState } from 'vuex';
import NewGameMixin from '@/common/mixins/home';
import modals from '@/common/modals';
import CategoryChoosed from './CategoryChoosed';

export default {
  name: 'pre-game-modal',
  mixins: [NewGameMixin],
  data() {
    return {
      categories: ['GEOGRAPHY', 'MOVIES', 'FOOD', 'ARTS', 'HISTORY', 'SPORTS', 'SCIENCE', 'WORLD', 'MATH', 'NATURE', 'LANGUAGES', 'MUSIC'],
      swipoCategories: [],
    };
  },
  created() {
    this.swipoInitThemes();
  },
  mounted() {
    if (this.swipoGameThemes === 'NO_CATEGORY') {
      setTimeout(() => {
        this.playGame(this.swipoGameThemes);
      }, this.swipoTimeForPreGameModals);
    } else if (this.swipoCategories.length === 1) {
      setTimeout(() => {
        this.playGame(this.swipoCategories[0]);
      }, this.swipoTimeForPreGameModals);
    }
  },
  methods: {
    ...mapActions('game', [
      'getThematicCategories',
    ]),
    ...mapMutations('game', [
      'updateGameType',
      'updateGameName',
      'updateColors',
    ]),
    ...mapMutations('common', [
      'storeModalForHomePage',
    ]),
    getColor(category) {
      return `rgb(${category.red}, ${category.green}, ${category.blue})`;
    },
    translateCategory(category) {
      return this.getTranslations[`game_category_${category}`];
    },
    swipoInitThemes() {
      if (this.swipoGameThemes === 'ALL') {
        this.swipoCategories = this.categories.map(value => ({ value, sort: Math.random() })).sort((a, b) => a.sort - b.sort).map(({ value }) => value);
        this.swipoCategories.splice(this.swipoCategories.length - 4, 4);
      } else if (this.swipoGameThemes === 'SEASONAL') {
        this.getThematicCategories().then((res) => {
          if (res.data.responseEnum === 'OPERATION_SUCCESS') {
            this.swipoCategories = res.data.data;
          } else {
            console.log('NO CATEGORY MODE ON...');
          }
        }).catch(error => console.error(error));
      } else if (this.swipoGameThemes !== 'NO_CATEGORY') {
        this.swipoCategories = this.swipoGameThemes.split(/[ ,]+/);
        if (this.swipoCategories.length >= 9) {
          this.swipoCategories.map(value => ({ value, sort: Math.random() })).sort((a, b) => a.sort - b.sort).map(({ value }) => value);
          this.swipoCategories.splice(12 - this.swipoCategories.length, 4 - (12 - this.swipoCategories.length));
        }
      } else {
        console.log('NO CATEGORY MODE ON...');
      }
    },
    showCategory(game) {
      this.storeModalForHomePage(CategoryChoosed);
      if (this.swipoGameThemes === 'SEASONAL') {
        const wantedCategory = this.swipoCategories.find(category => category.type === game);
        this.updateGameName(wantedCategory.name);
        this.updateColors(this.getColor(wantedCategory));
      }
      this.updateGameType(game);
      modals.showHideModal(this);
    },
  },
  computed: {
    ...mapState('common', [
      'userDetails',
      'swipoGameThemes',
      'modalForHomePage',
      'swipoTimeForPreGameModals',
    ]),
    ...mapGetters('i18n', [
      'getTranslations',
    ]),
    ...mapState('game', [
      'gameType',
    ]),
  },
};
</script>



// WEBPACK FOOTER //
// src/components/home/modals/pregame/PreGameModal.vue